import { makeAutoObservable } from 'mobx'
import type { RatingRow } from './Types'

/**
 * Local store of `CompleteTaskModal`.
 * Owns rating rows (per-day rating), driver's free-text comment, submitting
 * flag and error message.
 * Instantiated per modal mount via `useState(() => new CompleteTaskModalStore())`.
 */
export class CompleteTaskModalStore {
    rows: RatingRow[] = []
    driverComment = ''
    submitting = false
    error: string | null = null

    constructor() {
        makeAutoObservable(this)
    }

    setRows(rows: RatingRow[]): void {
        this.rows = rows
    }

    updateRow(i: number, patch: Partial<RatingRow>): void {
        this.rows = this.rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r))
    }

    setDriverComment(v: string): void {
        this.driverComment = v
    }

    setSubmitting(v: boolean): void {
        this.submitting = v
    }

    setError(v: string | null): void {
        this.error = v
    }
}
